// This component handles the App template used on every page.
import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IntlProvider, addLocaleData, FormattedMessage } from "react-intl";
import frenchLocaleData from "react-intl/locale-data/fr";
import classNames from "classnames";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as intlActions from "../intl/intlActions";
import ToastManager from "../common/ToastManager";

import { getEnvironmentProperties } from "../common/environmentProperties";

class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    addLocaleData(frenchLocaleData);
  }

  componentWillMount() {
    this.props.intlActions.setLocale(
      localStorage.getItem("languageCode") || "en-CA"
    );
  }

  render() {
    const { locale, messages } = this.props.intl;

    const {
      subtitle,
      color,
      displayEnvironmentOnScreen,
    } = getEnvironmentProperties();

    const appClassNames = classNames({
      "container-fluid": true,
      submitting: this.props.submitting,
    });
    return (
      <IntlProvider key={locale} locale={locale} messages={messages}>
        <div>
          {displayEnvironmentOnScreen && (
            <div className={"non-prod-banner"} style={{ background: `${color}` }}>
              <FormattedMessage id={`login.environments.${subtitle}`} />
            </div>
          )}
          <div className={appClassNames}>
            {this.props.children}
            <ToastContainer position="bottom-right" autoClose={5000} />
            <ToastManager />
          </div>
        </div>
      </IntlProvider>
    );
  }
}

App.propTypes = {
  children: PropTypes.object,
  intl: PropTypes.object,
  intlActions: PropTypes.object,
  submitting: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    intl: state.intl,
    submitting: !!state.data.submitting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    intlActions: bindActionCreators(intlActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/app/App.js